import { Page } from "../../../common/components/Page";
import { GuardianLinkStep } from "../components/GuardianLinkStep";

/**
 * /me/guardian — the guardian-linking screen inside the app (#2691). A minor in
 * look-only mode (no guardian yet, or paused) reaches it from the shell banner
 * and from any "Ask a guardian" prompt: ask by email, see the pending request,
 * or continue once a guardian approves.
 */
export function GuardianLinkPage() {
  return (
    <Page>
      <GuardianLinkStep headingLevel="h1" />
    </Page>
  );
}
